import { identifierAndTypenameToId } from "@/objects/@utils";
import { State } from "@/state";
import { threadNodeIdToTabId } from "@/state/threadTabs";

type ThreadRef = {
  id?: string | null;
  identifier?: string | null;
} | null;

/** Resolve the Relay global id for the thread backing a workflow execution. */
export function executionThreadNodeId(thread?: ThreadRef): string | null {
  if (!thread) return null;
  if (thread.id) return thread.id;
  if (thread.identifier) {
    return identifierAndTypenameToId(thread.identifier, "ThreadObject");
  }
  return null;
}

/**
 * Open (or toggle closed) the global thread panel for a workflow execution.
 * Accepts a nested ``thread`` object or a pre-resolved global id string.
 */
export function openExecutionThread(
  threadRef?: ThreadRef | string | null,
): void {
  const threadId =
    typeof threadRef === "string"
      ? threadRef
      : executionThreadNodeId(threadRef ?? null);
  if (!threadId) return;

  const st = State.getState();
  const activeTabId = threadNodeIdToTabId(st.activeThreadNodeId);
  const isAlreadySelected =
    st.activeThreadNodeId === threadId && st.isThreadPanelOpen;
  if (isAlreadySelected) {
    st.closeThreadTab(activeTabId);
    if (!st.isThreadPanelOpen) {
      st.closeAllPanels();
    }
    return;
  }

  st.openThreadTab(threadId);
}
